<template>
  <v-select
    id="axis-select"
    v-model="filter.eixoId"
    item-text="nome"
    item-name="eixoId"
    item-value="eixoId"
    :items="axis"
    :label="`${isAT ? 'Grupos de Iniciativa' : 'Grupos de Solução'}`"
    :placeholder="`${isAT ? 'Grupos de Iniciativa' : 'Grupos de Solução'}`"
    clearable
  >
    <template slot="no-data">
      Nenhum
      {{ isAT ? "Grupos de Iniciativa" : "Grupos de Solução" }} retornado
    </template>
  </v-select>
</template>

<script>
import { axisAPI } from "@/modules/axis";
import { mapGetters } from "vuex";

export default {
  name: "AppAxisCombobox",
  props: ["filter"],
  mounted() {
    this.loadAxis();
  },
  computed: {
    ...mapGetters(["isAT"]),
  },
  methods: {
    loadAxis() {
      axisAPI
        .list()
        .then((resp) => {
          this.axis = resp.data;
        })
        .catch();
    },
  },
  data() {
    return {
      axis: [],
    };
  },
};
</script>
